import P from "../../data/logoPaths.json";

// Original Café Amadeus lettering extracted from the logo artwork (logonuevoamadeus.ai)
export const LogoSvg = ({ part = "logo-full", className = "", ...rest }) => {
  const { vb, d, rule } = P[part];
  return (
    <svg viewBox={vb} className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {d.map((p, i) => (
        <path key={i} d={p} fillRule={rule[i]} />
      ))}
    </svg>
  );
};
